<template>
	<div>
		<li class="nav-main-heading">Truly Rich Club (TRC)</li>
		<li v-if="user.current_rank === 'BCC'" class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:href="route('member.bcc.join-trc')"
				data-bs-placement="bottom"
				title="Join to TRC now!"
				:class="{ active: $page.component === 'Member/BCC/JoinTRC' }"
			>
				<i class="nav-main-link-icon fa fa-user-plus"></i>
				<span class="nav-main-link-name">Join TRC</span>
			</inertia-link>
		</li>
		<li v-else-if="user.expiry > $page.props.dateToday" class="nav-main-item">
			<a
				class="nav-main-link"
				:class="{ active: $page.component === 'Member/Home' }"
				:href="route('member.home')"
				data-bs-placement="bottom"
				title="Go back to TRC Home"
			>
				<i class="nav-main-link-icon fa fa-arrow-left"></i>
				<span class="nav-main-link-name">TRC Home</span>
			</a>
		</li>
		<li v-else class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: $page.component === 'Member/Home' }"
				:href="route('member.account-expired.index')"
				data-bs-placement="bottom"
				title="Your subscription to TRC has been expired. Click here to renew"
			>
				<i class="nav-main-link-icon fa fa-arrow-left"></i>
				<span class="nav-main-link-name">Renew TRC</span>
			</inertia-link>
		</li>
		<li class="nav-main-heading">Navigations</li>
		<li class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:href="route('member.bcc.home')"
				:class="{ active: $page.component === 'Member/BCC/Home' }"
			>
				<i class="nav-main-link-icon fa fa-home"></i>
				<span class="nav-main-link-name">First Step</span>
			</inertia-link>
		</li>
		<div
			v-if="
				(user.current_rank === 'BCC' && user.expiry >= $page.props.dateToday) ||
				(user.current_rank !== 'BCC' && user.bcc_expiry >= $page.props.dateToday)
			"
		>
			<div v-if="sidebarMenus.bcc.hasOwnProperty('menus')">
				<li v-for="(bcc,key) in sidebarMenus.bcc.menus" :key="'mainmenu_' + bcc[0].slug" class="nav-main-item" :class="{ open: $page.props.slug == bcc[0].slug }">
					<a
						class="nav-main-link nav-main-link-submenu"
						data-toggle="submenu"
						:aria-haspopup="true"
						:aria-expanded="false"
						href="#"
					>
						<i class="nav-main-link-icon fa fa-video"></i>
						<span class="nav-main-link-name">{{ key }}</span>
					</a>
					<ul class="nav-main-submenu">
						<li v-for="submenu in bcc" :key="'submenu_' + submenu.sub_content_uuid" class="nav-main-item">
							<inertia-link
								class="nav-main-link"
								:href="route('member.bcc.content-slug',{slug:submenu.slug,uuid:submenu.sub_content_uuid})"
								:class="{ active: $page.props.uuid == submenu.sub_content_uuid }"
							>
								<span class="nav-main-link-name">{{submenu.title}}</span>
							</inertia-link>
						</li>
					</ul>
				</li>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	props: {
		user 			: Object,
		sidebarMenus 	: Object
	},
	setup(props) {
		const dateToday = () => {
			return moment(String(new Date())).format('YYYY-MM-DD')
		}
		return {
			dateToday,
		}
	},
}
</script>
